import $ from 'jquery';

const WORD_INTERVAL = 3000;

/**
 * Rotating words in a headline (.animate-heading with a .cd-words-wrapper),
 * used by properties/show and the "lancio" landing.
 */
export function initAnimatedHeadline() {
    $('.cd-words-wrapper b:first-child').addClass('is-visible');

    $('.animate-heading').each(function () {
        var headline = $(this);
        setTimeout(function () { hideWord(headline.find('.is-visible')); }, WORD_INTERVAL);
    });
}

function hideWord($word) {
    var nextWord = takeNext($word);
    switchWord($word, nextWord);
    setTimeout(function () { hideWord(nextWord); }, WORD_INTERVAL);
}

function takeNext($word) {
    return (!$word.is(':last-child')) ? $word.next() : $word.parent().children().eq(0);
}

function switchWord($oldWord, $newWord) {
    $oldWord.removeClass('is-visible').addClass('is-hidden');
    $newWord.removeClass('is-hidden').addClass('is-visible');
}
